export const dashboardRoutes = [
  {
    label: "dashboard",
    icon: "lucide:layout-dashboard",
    link: "/dashboard",
    color: "text-sky-500",
  },
  {
    label: "tools",
    icon: "lucide:wrench",
    color: "text-primary",
    submenu: true,
    children: [
      {
        label: "subtitle_downloader",
        icon: "lucide:captions",
        link: "/downloader",
        color: "text-primary",
      },
      {
        label: "multi_downloader",
        icon: "lucide:files",
        link: "/multi-downloader",
        color: "text-emerald-500",
      },
      {
        label: "playlistDownloader",
        icon: "lucide:list",
        link: "/playlist-downloader",
        color: "text-emerald-500",
      },
      {
        label: "regionChecker",
        icon: "lucide:globe",
        link: "/region-checker",
        color: "text-emerald-500",
      },
      {
        label: "youtubeTools",
        icon: "lucide:cpu",
        link: "/youtube-tools",
        color: "text-emerald-500",
      },
      {
        label: "summarize_subtitle",
        icon: "lucide:file-text",
        link: "/subtitle-summary",
        color: "text-emerald-500",
      },
      {
        label: "subtitle_translator",
        icon: "lucide:languages",
        link: "/subtitle-translator",
        color: "text-emerald-500",
      },
      {
        label: "audioToSubtitle",
        icon: "lucide:file-audio",
        link: "/video-to-subtitle",
        color: "text-emerald-500",
      },
      {
        label: "hardsubToSubtitle",
        icon: "lucide:scan-text",
        link: "/hardsub-to-subtitle",
        color: "text-primary",
      },
      {
        label: "subtitleTasks",
        icon: "lucide:list-checks",
        link: "/subtitle-tasks",
        color: "text-emerald-500",
        requiresAuth: true,
      },
      {
        label: "videoAudioSummary",
        icon: "lucide:file-text",
        link: "/video-audio-to-summary",
        color: "text-emerald-500",
      },
      {
        label: "chromeExtension",
        icon: "lucide:chrome",
        link: "https://chromewebstore.google.com/detail/downsub-%E2%80%94-subtitle-transc/gccfbdmnfkhelfcpbblmgkngahfdmmda?utm_source=downsub_member&utm_medium=dashboard&utm_campaign=chrome_extension",
        color: "text-primary",
      },
    ],
  },
  {
    label: "apiManagement",
    icon: "lucide:database",
    color: "text-emerald-500",
    submenu: true,
    requiresAuth: true,
    children: [
      {
        label: "api",
        icon: "lucide:square-terminal",
        link: "/api",
        color: "text-emerald-500",
        requiresAuth: false,
      },
      {
        label: "apiTester",
        icon: "lucide:zap",
        link: "/api-tester",
        color: "text-emerald-500",
        requiresAuth: true,
      },
      {
        label: "apiLogs",
        icon: "lucide:file-text",
        link: "/api-logs",
        color: "text-emerald-500",
        requiresAuth: true,
      },
      {
        label: "usageHistory",
        icon: "lucide:history",
        link: "/usage-history",
        color: "text-emerald-500",
        requiresAuth: true,
      },
    ],
  },
  {
    label: "preference",
    icon: "lucide:sliders",
    link: "/preference",
    color: "text-violet-500",
    requiresAuth: true,
  },
  {
    label: "settings",
    icon: "lucide:settings",
    link: "/settings",
    color: "text-violet-500",
    requiresAuth: true,
  },
  {
    label: "billing",
    icon: "lucide:credit-card",
    link: "/billing",
    color: "text-violet-500",
    requiresAuth: true,
  },
  {
    label: "contact",
    icon: "lucide:message-circle",
    link: "/contact",
    color: "text-violet-500",
  },
  // Admin-only group. Sidebar.vue filters `adminOnly` entries out for
  // non-admin users (app_metadata.isAdmin / role === "admin").
  {
    label: "admin",
    icon: "lucide:shield",
    color: "text-rose-500",
    submenu: true,
    adminOnly: true,
    children: [
      {
        label: "adminUsers",
        icon: "lucide:users",
        link: "/admin/users",
        color: "text-rose-500",
        adminOnly: true,
      },
      {
        label: "adminStatus",
        icon: "lucide:server",
        link: "/admin/status",
        color: "text-rose-500",
        adminOnly: true,
      },
    ],
  },
];
export const tools = [
  {
    label: "downloader",
    icon: "lucide:captions",
    link: "/downloader",
    color: "text-primary",
  },
  {
    label: "multiDownloader",
    icon: "lucide:files",
    link: "/multi-downloader",
    color: "text-emerald-500",
  },
  {
    label: "playlistDownloader",
    icon: "lucide:list",
    link: "/playlist-downloader",
    color: "text-primary",
  },
  {
    label: "regionChecker",
    icon: "lucide:globe",
    link: "/region-checker",
    color: "text-primary",
  },
  {
    label: "youtubeTools",
    icon: "lucide:cpu",
    link: "/youtube-tools",
    color: "text-emerald-500",
  },
  {
    label: "summarize_subtitle",
    icon: "lucide:file-text",
    link: "/subtitle-summary",
    color: "text-emerald-500",
  },
  {
    label: "subtitle_translator",
    icon: "lucide:languages",
    link: "/subtitle-translator",
    color: "text-emerald-500",
  },
  {
    label: "audioToSubtitle",
    icon: "lucide:file-audio",
    link: "/video-to-subtitle",
    color: "text-emerald-500",
  },
  {
    label: "hardsubToSubtitle",
    icon: "lucide:scan-text",
    link: "/hardsub-to-subtitle",
    color: "text-primary",
  },
  {
    label: "videoAudioSummary",
    icon: "lucide:file-text",
    link: "/video-audio-to-summary",
    color: "text-emerald-500",
  },
  {
    label: "chromeExtension",
    icon: "lucide:chrome",
    link: "https://chromewebstore.google.com/detail/downsub-%E2%80%94-subtitle-transc/gccfbdmnfkhelfcpbblmgkngahfdmmda?utm_source=downsub_member&utm_medium=dashboard&utm_campaign=chrome_extension",
    color: "text-primary",
  },
];

export const MAX_COUNT = 5;
export { MONTHLY_LIMIT, BONUS_LIMIT, BONUS_LIMIT_PRICE } from "~/constants/credits";
export const ITEMS_PER_PAGE = 10;
export { TRIAL_DAYS, TRIAL_CREDITS } from "~/constants/trial";
